module.exports = "/img/_/_/_/assets/images/avatar/full_right/male//warrior.jpg?adb4b2be92dc31cfac45d4d1f3257b19";